import React from 'react';
import styled from "styled-components";
import Link from "next/link";
import Icon from "@atoms/icon";
import BrandIcon from '@icons/bade_saba/logo.svg';

const BadeSabaNavbar = ({fluid, fixed, className}) => {
    return (
        <Container className={(fixed ? 'fixed-navbar ' : '') + (className ? className : '')}>
            <div className={fluid ? 'container-fluid' : 'container'}>
                <Card className="d-flex align-items-center justify-content-center">
                    <Link href={'/properties'} as={'/املاک-مشهد?badesaba=true'}>
                        <a title="۲نبش">
                            <Icon width={112}>
                                <BrandIcon/>
                            </Icon>
                        </a>
                    </Link>
                </Card>
            </div>
        </Container>
    );
};

export default BadeSabaNavbar;

// styles

const Container = styled.div`
    background-color: ${props => props.theme.white};
    border-bottom:1px solid ${props => props.theme.gray200};
    position: static;
    top: 0;
    right: 0;
    left: 0;
    z-index: 5001;
    
    &.fixed-navbar {
        position: fixed;
    }
    
    .modal-open & {
        z-index: 50 !important;
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        border-bottom: 0;
    }
`;

const Card = styled.div`
    height: 79px;
    background-color: ${props => props.theme.white};
    line-height: 0;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        height: 56px;
    }
    
    .bade-saba-icon {
        svg {
            g {
                path:first-child {
                    fill: ${propes => propes.theme.primary};
                }
            }
        }
    }
`;
